export enum ActiveExperiments {
  //**Keep this enum for testing purposes + having declared enum*/
  test = 'test',
  OR4Carousel = 'or4_wizard_carousel_images_order',
  //** After experiment is completed and code is productized please remove the enum from Active Experiments */
}
